<template>
    <div>
        <div class="form-group bmd-form-group search-area m-0 mb-1">
            <div class="row">
                <div class="col-lg-4 col-md-4 col-12 d-inline-block mt-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">دسته بندی :</span>
                        </div>
                        <vs-select :data="categories" :mode="'create'"
                                   :header="{multiple: false, label: 'name'}"
                                   @onChange="onSelectCategory"></vs-select>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4 mt-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                        </div>
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput" ref="searchInput" @keyup.enter="onModalShow"
                               v-model="searchString">
                        <button type="button" class="d-inline-block btn btn-info mx-2 barcode"
                                @click="openBarcode"><i
                                class="fa fa-camera"></i></button>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4 text-center mt-2">
                    <button class="btn btn-primary" @click="onModalButtonClick">افزودن محصول جدید</button>
                    <button class="btn btn-primary" @click="onModalShow">مشاهده فاکتور</button>
                    <button class="btn btn-danger" @click="onReturn" v-if="!fromEdit">ثبت مرجوعی</button>
                </div>
            </div>


        </div>
        <div class="row" v-if="listView">
            <!--<div class="col-lg-12 mt-3 mb-1">
                <div class="category-item" v-for="item in categories">
                    <h4>{{item.name}}</h4>
                </div>
            </div>-->
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0, noStock: item.stock < 1}" class="card list"
                     @click="onCardClicked($event, index)">
                    <div class="row">
                        <div class="col-md-5">
                            <strong>{{item.productName}}</strong>
                        </div>
                        <div class="col-md-3">
                            <span>موجودی: </span>
                            <span v-if="item.stock === undefined || item.stock === ''">0</span>
                            <span v-else>{{item.stock}} {{item.unitName}}</span>
                        </div>
                        <div class="col-md-2">
                            <span>تعداد: </span>
                            <span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>
                            <span v-else>{{item.unitVal}}</span>
                        </div>
                        <div class="col-md-2">
                            <span>قیمت: </span>
                            <span>{{item.sellPrice == null ? 0 :item.sellPrice.toLocaleString()}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-sm-6 product-container" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0, noStock: item.stock < 1}" class="card product mt-2 mb-2"
                     @click="onCardClicked($event, index)">
                    <div class="row p-2">
                        <div class="col-8">
                            <h5>{{item.productName}}</h5>
                            <span>موجودی انبار:</span>
                            <span>{{item.stock}} {{item.unitName}}</span>
                            <br>
                            <span>قیمت:</span>
                            <span>{{item.sellPrice == null ? 0 :item.sellPrice.toLocaleString()}}</span>
                            <br>
                            <span>تعداد:</span>
                            <span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>
                            <span v-else>{{item.unitVal}}</span>
                            <br>
                            <span>بارکد:</span>
                            <span>{{item.barcode}}</span>
                        </div>
                        <div class="col-4 d-flex align-items-center">
                            <img class="view-image" :src="item.imageAddress!==null && item.imageAddress !='' ? validateImageUrl(item.imageAddress) :noImageUrl()">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 mt-5 text-center" v-if="products !== undefined && products.length < 1">
                <h3 class="no-item-alert">محصولی یافت نشد!</h3>
            </div>
            <div class="col-lg-12 mt-5"
                 :style="[autoload && products.length < dataCount ? {'height': '125px'} : {'height': 'initial'}]">
                <div class="sk-circle" id="loading"
                     :style="[autoload ? {'margin': '20px 0'} : {'margin': '100px auto'}]">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div v-if="!autoload && products.length < dataCount" class="col-lg-12 text-center mb-3 mt-1"
                 @click="getProducts">
                <button class="btn btn-success">نمایش محصولات بیشتر</button>
            </div>


        </div>
        <!-- --------------------- M O D A L S ---------------------------------------------------------------------->
        <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
             aria-hidden="true">
            <div class="modal-dialog  modal-dialog-centered" style="max-width: 1140px;" role="document">
                <div class="modal-content" id="printMe">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شماره فاکتور</span>
                            </div>
                            <input class="form-control" type="number" v-model="voucher.voucherNumber"
                                   :placeholder=lastVoucherNumber>

                            <!--placeholder="شماره فاکتور-اگر خالی بگذارید بصورت اتوماتیک وارد میشود"-->

                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th class="text-nowrap">نام محصول</th>
                                    <!--<th class="text-center">قیمت خرید</th>-->
                                    <th class="text-center text-nowrap">تعداد</th>
                                    <th class="text-center text-nowrap">قیمت</th>
                                    <!--<th class="text-center text-nowrap">درصد تخفیف</th>-->
                                    <th class="text-center text-nowrap">تخفیف</th>
                                    <th class="text-center text-nowrap">جمع بعدازتخفیف</th>
                                    <th class="text-center text-nowrap">درصد مالیات</th>
                                    <th class="text-center text-nowrap">مبلغ مالیات</th>
                                    <th class="text-center text-nowrap">جمع</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in cart">
                                    <td class="product-remove-button text-nowrap pb-0"><a class="text-danger"
                                                                                          @click="onRemoveProductClicked(index)"><i
                                            class="fa fa-close"></i></a></td>
                                    <td class="min-vw-100 text-nowrap pb-0">{{item.productName}}</td>
                                    <!--<td class="text-center">
                                        <input class="form-control" type="number" v-model="item.price">
                                    </td>-->
                                    <td class="text-center  pb-0">
                                        <input class="form-control" style="min-width: 4rem;" type="number"
                                               v-model="item.unitVal">
                                        <small class="text-nowrap mt-2">{{item.unitName}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.sellPrice" @input="thousandSeprator2(item)">
                                        <small class="text-nowrap mt-2">{{item.salesPriceShow}}</small>
                                    </td>
                                    <!--<td class="text-center pb-0">-->
                                        <!--<input class="form-control" style="min-width: 6rem;" type="number"-->
                                               <!--v-model="item.percent">-->
                                    <!--</td>-->
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.discount">
                                        <small class="text-nowrap mt-2">{{thousandSeprator3(item.discount)}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <span class="form-control" style="min-width: 6rem;">{{((item.sellPrice-item.discount) * item.unitVal).toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.taxPercent">
                                        <!--<small class="text-nowrap mt-2">{{item.taxPercent}}</small>-->
                                    </td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number" readonly="true"
                                               v-model="item.taxPrice * item.unitVal">
                                        <!--<small class="text-nowrap mt-2">{{thousandSeprator3(item.taxPrice)}}</small>-->
                                    </td>


                                    <td class="text-center pb-0">
                                        <span class="form-control"
                                              style="min-width: 6rem;">{{((item.sellPrice-item.discount+ item.taxPrice) * item.unitVal).toLocaleString()}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="9"></td>
                                </tr>
                                <tr class="bg-total-discount mt-3">
                                    <td colspan="1"></td>
                                    <td class="text-right">
                                        <span>جمع کل : </span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>تعداد کل: </span>-->
                                        <span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>
                                        <span v-else>{{voucher.overallAmount}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>قیمت کل: </span>-->
                                        <span v-if="isNaN(voucherNoDiscount)" class="text-warning">مبلغ به درستی وارد نشده است!</span>
                                        <span v-else>{{voucherNoDiscount.toLocaleString()}}</span>
                                    </td>
                                    <td></td>
                                    <td class="text-center">
                                        <!--<span>جمع تخفیف : </span>-->
                                        <span v-if="isNaN(voucher.totalDiscount)" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{voucher.totalDiscount.toLocaleString()}}</span>
                                    </td>
                                    <td></td>
                                    <td class="text-center">
                                        <!--<span>جمع مالیات : </span>-->
                                        <span v-if="isNaN(vouchertotalTax)" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{(vouchertotalTax).toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>جمع  : </span>-->
                                        <span v-if="isNaN((voucherNoDiscount - voucher.totalDiscount+ vouchertotalTax))" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{(voucherNoDiscount - voucher.totalDiscount+ vouchertotalTax).toLocaleString()}}</span>
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                            <h4 class="text-center no-item-alert mt-5" v-if="cart.length < 1">محصولی ثبت نشده
                                است!</h4>
                        </div>
                        <div class="row">
                            <div class="input-group mt-2 col-4">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تخفیف فاکتور</span>
                                </div>
                                <input class="form-control" type="number" v-model="voucherDiscount"
                                       placeholder="تخفیف فاکتور">
                            </div>
                            <div class="input-group mt-2 col-4">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">درصد مالیات فاکتور</span>
                                </div>
                                <input class="form-control" type="number" v-model="vouchertaxPercent"
                                       placeholder="درصد مالیات فاکتور">
                            </div>
                            <div class="input-group mt-2 col-4">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">مبلغ مالیات فاکتور</span>
                                </div>
                                <span class="form-control">{{vouchertaxPrice.toLocaleString()}}</span>

                            </div>
                            <div class="input-group mt-2 col-12">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input class="form-control" type="text" v-model="voucher.description"
                                       placeholder="توضیحات" @keyup.enter="onPaymentClicked" ref="descriptionInput">
                            </div>
                            <div class="input-group mt-2 col-12">
                                <div class="input-group-prepend " @click="toggleStartDatePicker">
                                    <div class="input-group-text"><span>تاریخ فاکتور :</span></div>
                                </div>
                                <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                             ref="datePickerStart" style="flex: 1">
                                    <slot>
                                        <input v-model="voucherDatePersian" class="form-control date-input" readonly="true"
                                               @click="toggleStartDatePicker">
                                        <button class="close reset-date pr-2" @click="resetStartDate">×</button>
                                    </slot>
                                </date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-lg-6  w-100 text-right">
                                    <div class="row">
                                        <!--<div class="col-md-4">-->
                                        <!--<span>تعداد کل: </span>-->
                                        <!--<span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>-->
                                        <!--<span v-else>{{voucher.overallAmount}}</span>-->
                                        <!--</div>-->
                                        <!--<div class="col-md-8">-->
                                        <!--<span class="text-bold bg-total-cost p-1">مبلغ کل: </span>-->
                                        <!--<span v-if="isNaN(voucherNoDiscount)" class="text-warning">قیمت به درستی وارد نشده است!</span>-->
                                        <!--<span v-else class="text-bold bg-total-cost p-1">{{voucherNoDiscount.toLocaleString()}}</span>-->
                                        <!--</div>-->
                                        <!--<div class="col-md-6">-->
                                        <!--<span>جمع تخفیف: </span>-->
                                        <!--<span v-if="isNaN(voucher.totalDiscount)" class="text-warning">قیمت به درستی وارد نشده است!</span>-->
                                        <!--<span v-else>{{voucher.totalDiscount.toLocaleString()}}</span>-->
                                        <!--</div>-->
                                        <div class="col-12">
                                            <span class="text-bold bg-total-cost p-1">قابل پرداخت: </span>
                                            <span v-if="isNaN(voucher.overallPrice)" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                            <span v-else class="text-bold bg-total-cost p-1">{{voucher.overallPrice.toLocaleString()}}</span>
                                        </div>

                                    </div>
                                </div>
                                <div class=" col-lg-6  w-100 text-right d-inline-flex">
                                    <button type="button" class="btn btn-secondary m-1" data-dismiss="modal">بستن
                                    </button>
                                    <button type="button" class="btn btn-primary m-1" @click="onModalOk"
                                            v-if="cart.length > 0&& !fromEdit">بایگانی
                                    </button>
                                    <button type="button" class="btn btn-success m-1" @click="onPaymentClicked"
                                            v-if="cart.length > 0">دریافت
                                    </button>
                                     <button type="button" class="btn btn-warning m-1" @click="onPishClicked"
                                            v-if="cart.length > 0">پیش فاکتور
                                    </button>
                                    <!--<button type="button" class="d-inline-block btn btn-success m-1"-->
                                    <!--@click="onPrintClicked"><i-->
                                    <!--class="fa fa-print"></i></button>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="voucherDataReturn" tabindex="-1" role="dialog" aria-labelledby="voucherTitleReturn"
             aria-hidden="true">
            <div class="modal-dialog   modal-dialog-centered" style="max-width: 1140px;" role="document">
                <div class="modal-content" id="printMeReturn">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitleReturn">محصولات فاکتور</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th class="text-nowrap">نام محصول</th>
                                    <!--<th class="text-center">قیمت خرید</th>-->
                                    <th class="text-center text-nowrap">تعداد</th>
                                    <th class="text-center text-nowrap">قیمت</th>
                                    <th class="text-center text-nowrap">هزینه مرجوعی</th>
                                    <th class="text-center text-nowrap">جمع</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in cart">
                                    <td class="product-remove-button text-nowrap pb-0"><a class="text-danger"
                                                                                          @click="onRemoveProductClicked(index)"><i
                                            class="fa fa-close"></i></a></td>
                                    <td class="min-vw-100 text-nowrap pb-0">{{item.productName}}</td>
                                    <!--<td class="text-center">
                                        <input class="form-control" type="number" v-model="item.price">
                                    </td>-->
                                    <td class="text-center  pb-0">
                                        <input class="form-control" style="min-width: 4rem;" type="number"
                                               v-model="item.unitVal">
                                        <small class="text-nowrap mt-2">{{item.unitName}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.sellPrice" @input="thousandSeprator2(item)">
                                        <small class="text-nowrap mt-2">{{item.salesPriceShow}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.discount">
                                        <small class="text-nowrap mt-2">{{thousandSeprator3(item.discount)}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <span class="form-control" style="min-width: 6rem;">{{((item.sellPrice-item.discount) * item.unitVal).toLocaleString()}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6"></td>
                                </tr>
                                <tr class="bg-total-discount mt-3">
                                    <td colspan="1"></td>
                                    <td class="text-right">
                                        <span>جمع کل : </span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>تعداد کل: </span>-->
                                        <span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>
                                        <span v-else>{{voucher.overallAmount}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>قیمت کل: </span>-->
                                        <span v-if="isNaN(voucherNoDiscount)" class="text-warning">مبلغ به درستی وارد نشده است!</span>
                                        <span v-else>{{voucherNoDiscount.toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>جمع تخفیف : </span>-->
                                        <span v-if="isNaN(voucher.totalDiscount)" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{voucher.totalDiscount.toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>جمع تخفیف : </span>-->
                                        <span v-if="isNaN((voucherNoDiscount - voucher.totalDiscount))" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{(voucherNoDiscount - voucher.totalDiscount).toLocaleString() }}</span>
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                            <h4 class="text-center no-item-alert mt-5" v-if="cart.length < 1">محصولی ثبت نشده
                                است!</h4>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">هزینه مرجوعی فاکتور</span>
                            </div>
                            <input class="form-control" type="number" v-model="voucherDiscount"
                                   placeholder="هزینه مرجوعی فاکتور">
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات</span>
                            </div>
                            <input class="form-control" type="text" v-model="voucher.description"
                                   placeholder="توضیحات">
                        </div>

                    </div>
                    <div class="modal-footer d-block">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-lg-6  w-100 text-right">
                                    <div class="row">
                                        <!--<div class="col-md-4">-->
                                        <!--<span>تعداد کل: </span>-->
                                        <!--<span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>-->
                                        <!--<span v-else>{{voucher.overallAmount}}</span>-->
                                        <!--</div>-->
                                        <!--<div class="col-md-8">-->
                                        <!--<span class="text-bold bg-total-cost p-1">مبلغ کل: </span>-->
                                        <!--<span v-if="isNaN(voucherNoDiscount)" class="text-warning">قیمت به درستی وارد نشده است!</span>-->
                                        <!--<span v-else class="text-bold bg-total-cost p-1">{{voucherNoDiscount.toLocaleString()}}</span>-->
                                        <!--</div>-->
                                        <!--<div class="col-md-6">-->
                                        <!--<span>جمع تخفیف: </span>-->
                                        <!--<span v-if="isNaN(voucher.totalDiscount)" class="text-warning">قیمت به درستی وارد نشده است!</span>-->
                                        <!--<span v-else>{{voucher.totalDiscount.toLocaleString()}}</span>-->
                                        <!--</div>-->
                                        <div class="col-12">
                                            <span class="text-bold bg-total-cost p-1">قابل پرداخت: </span>
                                            <span v-if="isNaN(voucher.overallPrice)" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                            <span v-else class="text-bold bg-total-cost p-1">{{voucher.overallPrice.toLocaleString()}}</span>
                                        </div>

                                    </div>
                                </div>
                                <div class=" col-lg-6  w-100 text-right d-inline-flex">
                                    <button type="button" class="btn btn-secondary m-1" data-dismiss="modal">بستن
                                    </button>
                                    <!--<button type="button" class="btn btn-primary m-1" @click="onModalOk"-->
                                    <!--v-if="cart.length > 0">ذخیره-->
                                    <!--</button>-->
                                    <button type="button" class="btn btn-success m-1" @click="onPaymentClickedReturn"
                                            v-if="cart.length > 0">پرداخت
                                    </button>
                                    <!--<button type="button" class="d-inline-block btn btn-success m-1"-->
                                    <!--@click="onPrintClickedReturn"><i-->
                                    <!--class="fa fa-print"></i></button>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ------------------------------------------------------------------------------------------->
        <div class="modal fade" id="barcodeModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitleBarcode"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitleBarcode">خواندن بارکد
                            محصول</h5>

                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mt-3">
                        <div class="row">
                            <div class="col-12">

                                <StreamBarcodeReader
                                        @decode="(a, b, c) => onDecode(a, b, c)"
                                        @loaded="() => onLoaded()"
                                ></StreamBarcodeReader>
                                <h5 class="col-12 text-center m-3">{{ barcode || "هیچ بارکدی قرائت نشده، لطفا دوربین را روی بارکد بگیرید" }}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <!--<button type="button" class="btn btn-danger mr-2" @click="onModalDelete">حذف</button>-->
                        <!--<button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="productModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitleProduct"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitleProduct">ایجاد
                            محصول</h5>

                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mt-3">
                        <div class="row">
                            <div class="col-lg-9 col-md-12 col-sm-12 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">دسته بندی</span>
                                    </div>
                                    <vs-select :data="categories" :selected-val="preselectedCategory"
                                               :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="onCategoryChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-12 col-sm-12 text-center">
                                <button class="btn btn-primary bg-danger-grad border-0"
                                        @click="onAddCategoryClicked" data-toggle="tooltip" data-placement="bottom"
                                        title="افزودن دسته بندی">افزودن دسته بندی
                                </button>
                            </div>
                            <div class="col-lg-12 mt-3 mt-lg-0">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام محصول</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.productName">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">واحد</span>
                                    </div>
                                    <vs-select :data="units" :selected-val="preselectedUnit"
                                               :mode="'create'" :header="{multiple: false, label: 'unitName'}"
                                               @onChange="onUnitChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">بارکد</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="product.barcode">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تعداد هشدار کسر موجودی</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.lessAmount">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد فنی</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.technicalCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شناسه مالیاتی</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.taxCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">درصد مالیات</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.defultTaxPercent">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد محصول</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.productCode">
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onProductModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="category-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-danger glow-warning">
                        <h5 class="modal-title text-white">افزودن دسته بندی</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row text-center">
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">عنوان دسته بندی</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="categoryName">
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onCreateCategory">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import EventBus from "../_framework/event-bus.js";
    import DatePicker from '../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from '../_framework/VsSelect.vue';
    import VueHtmlToPaper from 'vue-html-to-paper';
    import {StreamBarcodeReader} from "vue-barcode-reader";
    import Moment from "moment-jalali";


    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'sell',
        components: {
            DatePicker,
            VsSelect,
            StreamBarcodeReader
        },
        data() {
            return {
                lastVoucherNumber:"",
                barcodeInputTimeout: null,
                isBarcodeScanning: false,
                isModalOpen: true,
                products: [],
                categories: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    showAll: false,

                },
                searchString: "",
                modalProductName: "",
                cart: [],
                payments: [],
                voucher: {
                    description: "",
                    receiveOutSourceId: 0,
                    voucherProductDto: [],
                    outSourceName: "",
                    overallAmount: 0,
                    overallPrice: 0,
                    taxPercent: 0,
                    taxPrice: 0,
                    discount: 0,
                    voucherDate: "0001-01-01",
                    voucherNumber: null
                },
                voucherDatePersian: "",
                tempVoucher: [],
                outSourceName: "",
                dataCount: 0,

                listView: false,
                autoload: false,

                userId: 0,
                companyId: 0,
                fromEdit: false,
                barcode: "",
                categoryName: "",
                preselectedCategory: {},
                product: {
                    productName: "",
                    unitId: 0,
                    barcode: "",
                    categoryId: 0,
                },
                units: [],
                preselectedUnit: {},
                voucherDiscount: 0,
                vouchertaxPercent: 0,
                vouchertaxPrice: 0,
                vouchertotalTax: 0,
                overallProductPrice: 0,
                voucherNoDiscount: 0,
                isSending: false,
                receiveOutSourceId: null,
                receiveOutSourceName: "",

            }
        },
        mounted() {
            const cc = localStorage.getItem("salemali_close");
            if (cc !== undefined && cc != null && cc === "true") {
                Utils.handleErrorWithNotification("سال مالی بسته شده است و امکان ثبت جدید وجود ندارد", this.$noty);
                this.$router.push({name: 'home'});
            }
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            // console.log(this.$route.params);
            Vue.use(VueHtmlToPaper, printoptions);
            this.userId = localStorage.getItem("userId");
            this.companyId = localStorage.getItem("companyId");
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            if (this.$route.params.id !== undefined && this.$route.params.id !== null) {
                console.log(this.$route.params.outSourceName)
                this.receiveOutSourceId = this.$route.params.id;
                this.receiveOutSourceName = this.$route.params.outSourceName;
            }
            this.fromEdit = this.$route.params.fromEdit;
            if (localStorage.getItem("auth_token") === null) {
                this.$noty.error('لطفا مجددا وارد شوید!');
                this.$router.push({name: 'login'});
            } else {
                // this.queryParams.companyId = this.companyId;
                new BaseService('product').getList(this.queryParams).then(response => {
                    this.products = response.data.data;
                    this.dataCount = response.data.count;
                    if (this.$route.params.voucher !== undefined) {
                        this.cart = this.$route.params.voucher.voucherProductDto;
                        // console.log(this.$route.params.voucher)
                        this.voucher.description = this.$route.params.voucher.description;
                        this.voucher.discount = this.$route.params.voucher.discount;
                        this.voucher.taxPrice =this.$route.params.voucher.taxPrice;
                        this.voucher.taxPercent =this.$route.params.voucher.taxPercent;

                        this.vouchertaxPrice = this.$route.params.voucher.taxPrice;
                        this.vouchertaxPercent= this.$route.params.voucher.taxPercent;
                        this.validateProductsList();
                    }
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            }
            new BaseService('categories').getAll().then(response => {
                this.categories = response.data;
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });

            new BaseService('voucher/getlastVoucherNumber/1').getList().then(response => {
                this.lastVoucherNumber = response.data;
                if(this.lastVoucherNumber!==undefined && this.lastVoucherNumber!== null && this.lastVoucherNumber>0){
                    this.lastVoucherNumber ++;
                    this.lastVoucherNumber =  "اگر خالی بگذارید بصورت اتوماتیک " + this.lastVoucherNumber + " وارد میشود";
                }else{
                    this.lastVoucherNumber =100;
                }
            }).catch(error => {
                // error
                this.lastVoucherNumber =100;
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });

            /*new BaseService('outsource').getById(this.$route.params.id).then(response => {
                this.outSourceName = response.data.outSourceName;
            }).catch(error => {
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });*/
            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.products.length < this.dataCount) {
                        $("#loading").show();
                        this.getProducts();

                    }
                });
            }


            //localStorage.removeItem("tempVoucher");

            if (localStorage.getItem(`tempVoucherSell${this.userId}${this.companyId}`) === null) {
                localStorage.setItem(`tempVoucherSell${this.userId}${this.companyId}`, "[]");
            }

            /*new BaseService('categories').getAll().then(response => {
                this.categories = response.data.data;
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });*/
            this.getUnits();
            let tod = Moment(new Date()).format('YYYY-MM-DD');
            this.voucherDatePersian = Moment(tod, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
            this.$refs.searchInput.focus();
        },
        methods: {
            getUnits() {
                new BaseService('units').getAll().then(response => {
                    this.units = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });

            },
            getCategories() {
                new BaseService('categories').getAll().then(response => {
                    this.categories = response.data;
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            getProducts() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('product').getList(this.queryParams).then(response => {
                    this.products.push.apply(this.products, response.data.data);
                    this.validateProductsList();
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onSelectCategory(val) {
                this.queryParams.categoryId = val.id;
                this.queryParams.pageIndex = 0;
                $("#loading").hide();
                new BaseService('product', '/get').getList(this.queryParams).then(response => {
                    // new BaseService('product?pageSize='
                    //     + this.queryParams.pageSize
                    //     + '&pageIndex='
                    //     + this.queryParams.pageIndex
                    //     + '&name='
                    //     + this.queryParams.name
                    //     + '&showAll='
                    //     + this.queryParams.showAll).getList().then(response => {
                    this.products = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });

            },
            onSearchInput() {
                if (this.barcodeInputTimeout) {
                    clearTimeout(this.barcodeInputTimeout);
                }
                this.isBarcodeScanning = true;
                this.barcodeInputTimeout = setTimeout(() => {
                    if (this.searchString.length >= 13) {
                        this.queryParams.name = this.searchString;
                        this.queryParams.pageIndex = 0;
                        let queryParams2 = {
                            name: this.searchString,
                            showAll: false,
                            pageSize: 1800,
                            pageIndex: 0,
                        };
                        $("#loading").hide();
                        new BaseService('product').getList(queryParams2).then(response => {
                            this.products = response.data.data;
                            if (this.products.length === 1) {
                                this.$refs.searchInput.select();
                                this.onCardClicked(null, 0);
                            }
                            this.validateProductsList();
                            $("#loading").hide();
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.message, this.$noty);
                        });
                    } else {
                        this.queryParams.name = this.searchString;
                        this.queryParams.pageIndex = 0;
                        let queryParams2 = {
                            name: this.searchString,
                            showAll: false,
                            pageSize: 1800,
                            pageIndex: 0,
                        };
                        $("#loading").hide();
                        new BaseService('product').getList(queryParams2).then(response => {
                            this.products = response.data.data;
                            if (this.products.length === 1) {
                                this.$refs.searchInput.select();
                                this.onCardClicked(null, 0);
                            }
                            this.validateProductsList();
                            $("#loading").hide();
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.message, this.$noty);
                        });
                    }
                    this.isBarcodeScanning = false;
                }, 300); // مدت زمان تایمر به میلی‌ثانیه، می‌توانید تنظیم کنید
            },
            validateProductsList() {
                for (let item of this.cart) {
                    for (let product of this.products) {
                        if (item.productName === product.productName) {
                            product.unitVal = item.unitVal;
                            product.price = item.salesPrice;
                            if (item.discount === undefined || isNaN(item.discount) || item.discount === null) {
                                item.discount = 0;
                            }
                            if (item.percent === undefined || isNaN(item.percent) || item.percent === null) {
                                item.percent = 0;
                            }
                        }
                    }
                }
            },
            onCardClicked(e, index) {
                let flag = false;
                let i = 0;
                let offset = 0;
                for (let item of this.cart) {
                    if (item.productName === this.products[index].productName) {
                        flag = true;
                        offset = i;
                    }
                    i++;
                }
                if (flag === false) {
                    this.products[index].unitVal++;
                    Vue.set(this.products[index], "originalPrice", this.products[index].price);
                    Vue.set(this.products[index], "salesPrice", this.products[index].sellPrice);
                    Vue.set(this.products[index], "discount", 0);
                    Vue.set(this.products[index], "percent", 0);
                    Vue.set(this.products[index], "taxPercent", this.products[index].defultTaxPercent);
                    Vue.set(this.products[index], "taxPrice", this.products[index].defultTaxPercent * this.products[index].salesPrice);

                    this.cart.push(this.products[index]);
                } else {
                    this.cart[offset].unitVal++;
                    //this.products[index].unitVal++;
                }
            },
            onRemoveProductClicked(index) {
                for (let item of this.products) {
                    if (item.productName === this.cart[index].productName) {
                        /*item.count = 0;*/
                        item.unitVal = 0;
                        // item.price = item.originalPrice;
                    }
                }
                this.cart.splice(index, 1);

            },
            onModalShow() {
                if (!this.isBarcodeScanning) {
                    this.voucher.overallPrice = 0;
                    this.voucher.overallAmount = 0;
                    this.voucherNoDiscount = 0;
                    for (let item of this.cart) {
                        item = this.thousandSeprator2(item);

                        if (item.discount === 0 || item.discount === null || isNaN(item.discount)) {
                            item.discount = 0;
                            if (item.percent === 0) {

                            } else {
                                item.discount = (item.sellPrice * item.percent) / 100;
                            }
                        } else {
                            item.percent = Math.ceil(((item.discount * 100) / item.sellPrice) * 100) / 100;

                        }
                        item.taxPrice = (item.salesPrice - item.discount) * item.taxPercent * 0.01;

                        this.voucher.overallPrice += ((item.salesPrice - item.discount + item.taxPrice) * item.unitVal);
                        this.voucherNoDiscount += (item.salesPrice * item.unitVal);
                        this.voucher.overallAmount += item.unitVal;
                        // this.vouchertotalTax += (i.taxPrice * i.unitVal);
                        // item.percent = Math.ceil(((item.discount * 100) / item.salesPrice) * 100) / 100;
                    }
                    if (this.voucher.discount !== undefined || this.voucher.discount !== null || !isNaN(this.voucher.discount)) {
                        this.voucherDiscount = this.voucher.discount;
                    }
                    // console.log(this.voucher)
                    // console.log(this.cart)
                    $("#voucherData").modal("show");
                    $('#voucherData').on('shown.bs.modal', () => {
                        $(document).on('keyup.modal', (e) => this.onModalKeyUp(e));
                    });
                    $('#voucherData').on('hidden.bs.modal', () => {
                        $(document).off('keyup.modal');
                    });
                }
            },
            onModalKeyUp(event) {
                if (event.key === 'Enter') {
                    this.onPaymentClicked();
                }
            },
            onModalOk() {
                if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                    for (let item of this.cart) {
                        item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                        item.salesPrice = item.sellPrice === null ? 0 : parseInt(item.sellPrice);
                        item.price = item.price === null ? parseInt(item.salesPrice) : parseInt(item.price);
                        // item.price = item.salesPrice;
                        Vue.set(item, "productId", item.id);
                    }
                    if (this.$route.params.voucher !== undefined) {
                        let desc = this.voucher.description;
                        this.voucher = this.$route.params.voucher;
                        this.voucher.description = desc;
                    } else {
                        this.voucher.voucherProductDto = this.cart;
                        // this.voucher.receiveOutSourceId = parseInt(this.queryParams.outsourceId);
                        this.voucher.receiveOutSourceId = this.receiveOutSourceId;
                        this.voucher.receiveOutSourceName = this.receiveOutSourceName;
                    }
                    this.tempVoucher = JSON.parse(localStorage.getItem(`tempVoucherSell${this.userId}${this.companyId}`));
                    this.tempVoucher.push(this.voucher);
                    localStorage.setItem(`tempVoucherSell${this.userId}${this.companyId}`, JSON.stringify(this.tempVoucher));

                    $("#voucherData").modal("hide");
                    this.isModalOpen = false;
                    window.removeEventListener('keyup', this.onModalKeyUp);
                    this.$noty.info("فاکتور ذخیره شد. برای تکمیل عملیات به بخش بایگانی، فاکتورهای بایگانی شده مراجعه کنید.");
                    for (let item of this.products) {
                        item.unitVal = 0;
                        // item.price = item.originalPrice;
                    }
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }

                /*new BaseService('voucher').create(this.voucher).then(response => {
                    this.$noty.success("موفقیت آمیز!");
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                })*/
            },
            onPishClicked() {
                if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                    for (let item of this.cart) {
                        item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                        item.salesPrice = item.sellPrice === null ? 0 : parseInt(item.sellPrice);
                        item.price = item.price === null ? parseInt(item.salesPrice) : parseInt(item.price);
                        //item.price = item.salesPrice;
                        Vue.set(item, "productId", item.id);
                    }
                    this.voucher.voucherProductDto = this.cart;
                    // this.voucher.receiveOutSourceId = parseInt(this.queryParams.outsourceId);
                    this.voucher.receiveOutSourceId = this.receiveOutSourceId;
                    this.voucher.receiveOutSourceName = this.receiveOutSourceName;
                    this.voucher.description = "پیش فاکتور " + this.voucher.description;
                    $("#voucherData").modal("hide");
                    this.isModalOpen = false;
                    window.removeEventListener('keyup', this.onModalKeyUp);
                    new BaseService('voucher').create(this.voucher).then(response => {
                        let voucherId = response.data.data;
                        new BaseService('voucher', `/payment/${voucherId}`).create(this.payments).then(response => {
                        this.$noty.success('پیش فاکتور با موفقیت ثبت شد');
                            // this.$noty.success("سند با موفقیت ثبت شد!");

                            this.$router.push({name: 'home'});
                        }).catch(error => {
                            this.isPaying = false;
                            this.$noty.error(error.response.message);
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        })
                        // let obj = {
                        //     name: 'home',
                        // };
                        // this.$router.push(obj);
                    }).catch(error => {
                        this.$noty.error(error);
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });

                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }

            },
            onPaymentClicked() {
                if (this.$route.params.fromEdit) {
                    if (confirm("در صورت تایید اطلاعات قبلی پرداخت فروش و کالاهای آن حذف میشوند و اطلاعات جدید جایگزین میشوند. آیا از پرداخت اطمینان دارید؟")) {
                        if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                            new BaseService('Voucher', `/DeleteVoucher/${this.$route.params.voucher.id}`).create().then(response => {

                                for (let item of this.cart) {
                                    item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                                    item.salesPrice = item.sellPrice === null ? 0 : parseInt(item.sellPrice);
                                    item.price = item.price === null ? parseInt(item.salesPrice) : parseInt(item.price);
                                    // item.sellPrice = item.salesPrice;
                                    Vue.set(item, "productId", item.id != null || item.id != undefined ? item.id : item.productId);
                                }
                                this.voucher.voucherProductDto = this.cart;
                                // this.voucher.receiveOutSourceId = parseInt(this.queryParams.outsourceId);
                                this.voucher.receiveOutSourceId = this.receiveOutSourceId;
                                this.voucher.receiveOutSourceName = this.receiveOutSourceName;
                                $("#voucherData").modal("hide");
                                this.isModalOpen = false;
                                window.removeEventListener('keyup', this.onModalKeyUp);
                                let obj = {
                                    name: 'payment',
                                    params: {
                                        voucher: this.voucher,
                                        type: "sell"
                                    }
                                };
                                this.$router.push(obj);
                            }).catch(error => {
                                console.log(error)
                                Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                            });


                        } else {
                            this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                        }
                    }
                } else {
                    if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                        for (let item of this.cart) {
                            item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                            item.salesPrice = item.sellPrice === null ? 0 : parseInt(item.sellPrice);
                            item.price = item.price === null ? parseInt(item.salesPrice) : parseInt(item.price);
                            //item.price = item.salesPrice;
                            Vue.set(item, "productId", item.id);
                        }
                        this.voucher.voucherProductDto = this.cart;
                        // this.voucher.receiveOutSourceId = parseInt(this.queryParams.outsourceId);
                        this.voucher.receiveOutSourceId = this.receiveOutSourceId;
                        this.voucher.receiveOutSourceName = this.receiveOutSourceName;
                        $("#voucherData").modal("hide");
                        this.isModalOpen = false;
                        window.removeEventListener('keyup', this.onModalKeyUp);
                        let obj = {
                            name: 'payment',
                            params: {
                                voucher: this.voucher,
                                type: "sell"
                            }
                        };
                        this.$router.push(obj);
                    } else {
                        this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                    }
                }
            },
            onPaymentClickedReturn() {
                if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                    for (let item of this.cart) {
                        item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                        item.salesPrice = item.sellPrice === null ? 0 : parseInt(item.sellPrice);
                        item.price = item.price === null ? parseInt(item.salesPrice) : parseInt(item.price);
                        //item.price = item.salesPrice;
                        Vue.set(item, "productId", item.id);
                    }
                    this.voucher.voucherProductDto = this.cart;
                    this.voucher.receiveOutSourceId = parseInt(this.queryParams.outsourceId);
                    this.voucher.outSourceName = this.outSourceName;
                    $("#voucherDataReturn").modal("hide");
                    let obj = {
                        name: 'payment',
                        params: {
                            voucher: this.voucher,
                            type: "sell",
                            sellReturn: true
                        }
                    };
                    this.$router.push(obj);
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }

            },
            calculateOverallAmount() {
                let amount = 0;
                for (let item of this.cart) {
                    amount += parseFloat(item.unitVal);
                }
                this.voucher.overallAmount = amount;
            },
            calculateOverallPrice() {
                let price = 0;
                let discount = 0;
                let totalTax = 0;
                for (let item of this.cart) {
                    price += (parseFloat(item.unitVal) * parseInt(item.sellPrice));
                    if (item.discount === 0 || item.discount === null || isNaN(item.discount)) {
                        item.discount = 0;
                        if (item.percent === 0) {

                        } else {
                            item.discount = (item.sellPrice * item.percent) / 100;
                        }
                    } else {
                        item.percent = Math.ceil(((item.discount * 100) / item.sellPrice) * 100) / 100;

                    }
                    item.taxPrice = (item.salesPrice - item.discount) * item.taxPercent * 0.01;

                    discount += (parseFloat(item.unitVal) * parseInt(item.discount));
                    totalTax += (parseFloat(item.unitVal) * parseInt(item.taxPrice));

                }
                this.voucherNoDiscount = price;

                this.vouchertotalTax = totalTax;
                this.voucher.totalDiscount = discount;
                this.voucher.totalTax = totalTax;
                this.overallProductPrice = price - discount + totalTax;


                this.vouchertaxPrice = this.voucher.taxPercent * 0.01 * (this.overallProductPrice - this.voucherDiscount);
                this.voucher.taxPrice = this.vouchertaxPrice;
                this.voucher.overallPrice = this.overallProductPrice - this.voucherDiscount + this.voucher.taxPrice;


            },
            onReturn() {
                if (this.fromEdit) {
                    if (confirm("در صورت تایید اطلاعات پرداخت فروش و کالاهای آن حذف میشوند. آیا مرجوعی را تایید میکنید؟")) {
                        new BaseService('Voucher', `/DeleteVoucher/${this.$route.params.voucher.id}`).create().then(response => {


                            let obj = {
                                name: 'home',

                            };
                            this.$router.push(obj);
                        }).catch(error => {
                            console.log(error)
                            Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                        });
                    }
                } else {
                    for (let item of this.cart) {
                        item = this.thousandSeprator2(item);
                    }

                    $("#voucherDataReturn").modal("show");
                }
            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            onPrintClickedReturn() {
                this.$htmlToPaper('printMeReturn');
            },
            onDecode(a, b, c) {
                // console.log(a, b, c);
                this.barcode = a;
                this.searchString = a;
                this.onSearchInput();
                $("#barcodeModal").modal("hide");
                // if (this.id) clearTimeout(this.id);
                // this.id = setTimeout(() => {
                //     if (this.text === a) {
                //         this.text = "";
                //     }
                // }, 5000);
            },
            onLoaded() {
                // console.log("load");
            },
            openBarcode() {
                this.barcode = "";
                $("#barcodeModal").modal("show");
            },
            thousandSeprator(a) {

                let amount = a;
                let showprice = "";

                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                this.$noty.success(showprice, {
                    timeout: 1000,
                    layout: 'topCenter'
                });

            },
            onModalButtonClick() {
                $("#productModal").modal("show");
                let na = this.product.productName;
                this.product = {};
                if (this.preselectedUnit.id !== null) {
                    this.product.unitId = this.preselectedUnit.id;
                }
                if (this.preselectedCategory.id !== null) {
                    this.product.categoryId = this.preselectedCategory.id;
                }
                if (na !== null && na !== '') {
                    this.product.productName = na;
                }
            },
            onCategoryChange(e) {
                if (e && e.id != null) {
                    this.preselectedCategory = e;
                    this.product.categoryId = e.id;
                }
            },
            onAddCategoryClicked() {
                $("#category-modal").modal("show");
                // this.$router.push({name: 'category'});
            },
            onUnitChange(e) {
                if (e && e.id != null) {
                    this.preselectedUnit = e;
                    this.product.unitId = e.id;
                }
            },
            onProductModalOk() {
                this.onCreateProduct(this.product);
            },
            onCreateProduct(product) {
                if (!this.isSending) {
                    this.isSending = true;
                    // console.log(product)
                    if (product.categoryId === undefined || product.categoryId === null) {
                        Utils.handleErrorWithNotification("لطفا دسته بندی را انتخاب کنید", this.$noty);
                    } else if (product.unitId === undefined || product.unitId === null) {
                        Utils.handleErrorWithNotification("لطفا واحد را انتخاب کنید", this.$noty);
                    } else {
                        product.rowVersion = this.generateUuid();
                        new BaseService('product').create(product).then(response => {
                            this.$noty.success("موفقیت آمیز!");
                            $("#productModal").modal("hide");
                            this.queryParams.pageIndex = 0;
                            new BaseService('product', '/get').getList(this.queryParams).then(response => {
                                this.products = response.data.data;
                                $("#loading").hide();
                            }).catch(error => {
                                // error
                                Utils.handleErrorWithNotification(error.data.messages, this.$noty);
                            });
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                            Utils.handleErrorWithNotification(error.data.errors[0].message, this.$noty);
                        })
                    }
                }
            },
            onCreateCategory() {
                if (!this.isSending) {
                    this.isSending = true;
                    let category = {
                        name: this.categoryName,
                        companyId: parseInt(localStorage.getItem("companyId")),
                        id: 0,
                        // parentCategoryId: this.parentCategoryId
                    };
                    category.rowVersion = this.generateUuid();
                    new BaseService('categories').create(category).then(response => {
                        this.$noty.success("دسته بندی با موفقیت افزوده شد.");
                        $("#category-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        this.getCategories();
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            thousandSeprator2(a) {
                if (a.sellPrice === undefined) {
                    a.sellPrice = a.salesPrice;
                }
                let amount = a.sellPrice;
                let showprice = "";

                if (amount !== '' && amount !== undefined && amount !== 0 && amount !== '0' && amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                a.salesPriceShow = showprice;
                return a;
            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            onStartDatePicked(val) {
                this.voucher.voucherDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.voucherDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetStartDate() {
                this.voucher.voucherDate = "0001-01-01";
                this.voucherDatePersian = '';
            },

        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                this.isModalOpen = false;
                window.removeEventListener('keyup', this.onModalKeyUp);
                next(false);
            } else {
                next();
            }
        },
        watch: {
            cart: {
                handler(val) {
                    this.calculateOverallAmount();
                    this.calculateOverallPrice();
                },
                deep: true
            },
            voucherDiscount(val) {
                this.voucher.discount = val;
                this.calculateOverallPrice();
            },
            vouchertaxPercent(val) {
                this.voucher.taxPercent = val;
                this.calculateOverallPrice();
            }
        }
    }
</script>
<style>
    @media (max-width: 991px) {
        .barcode {
            display: block !important;
        }
    }

    @media (min-width: 990px) {
        .barcode {
            display: none !important;
        }
    }
</style>